/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, List, Typography } from 'antd';
import EditTransactionLimits from 'components/bank/AGBBank/EditTransactionLimits';
import { useLanguage } from 'hooks/Language/useLanguage';

const { Text } = Typography;

const TransactionLimits = ({
  cardItem,
  updateTransactionLimitOption,
}: {
  updateTransactionLimitOption: any;
  cardItem: any;
}) => {
  const { translate } = useLanguage();
  const {
    form,
    currency,
    onCloseEditTransactionLimitModal,
    openModal,
    selectedTransaction,
    onHandleEditTransactionLimit,
  } = updateTransactionLimitOption;
  return (
    <Flex gap="middle" vertical style={{ width: '100%' }}>
      <Flex vertical style={{ width: '100%' }}>
        <List
          style={{ width: '100%' }}
          dataSource={[
            <Flex
              justify="space-between"
              align="center"
              style={{ width: '100%' }}
            >
              <Flex
                align="flex-start"
                style={{ width: '100%' }}
                vertical
              >
                <Text type="secondary">
                  {translate('Max limit per transaction')}
                </Text>

                <span className="medium-text">
                  {cardItem && cardItem?.SafeLimite}
                </span>
              </Flex>
            </Flex>,
            <Flex
              justify="space-between"
              align="center"
              style={{ width: '100%' }}
            >
              <Flex
                align="flex-start"
                style={{ width: '100%' }}
                vertical
              >
                <Text type="secondary">
                  {translate('Max daily limit')}
                </Text>
                <span className="medium-text">
                  {cardItem && cardItem?.MaxTransPerDay}
                </span>
              </Flex>
            </Flex>,
          ]}
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      </Flex>
      <EditTransactionLimits
        form={form}
        onClose={onCloseEditTransactionLimitModal}
        open={openModal}
        maximumLimit={selectedTransaction}
        currency={currency}
        title="Maximum transaction limit"
        onHandleSubmit={onHandleEditTransactionLimit}
      />
    </Flex>
  );
};

export default TransactionLimits;
